"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingTransactionValidation = void 0;
const ChargerFaultCategoryValidation_1 = require("./ChargerFaultCategoryValidation");
const ChargerPortStateValidation_1 = require("./ChargerPortStateValidation");
const DiagnosticFileTypeValidation_1 = require("./DiagnosticFileTypeValidation");
const FinishReasonValidation_1 = require("./FinishReasonValidation");
const PowerQualityIssueValidation_1 = require("./PowerQualityIssueValidation");
class ChargingTransactionValidation {
    static isValid(entity) {
        // Validate entity.id for existence and correct type.
        if (entity.id == undefined)
            return false;
        if (typeof entity.id !== "string")
            return false;
        // Validate entity.last_known_state for existence and correct type.
        if (entity.last_known_state == undefined)
            return false;
        if (!ChargerPortStateValidation_1.ChargerPortStateValidation.isValid(entity.last_known_state))
            return false;
        // Validate entity.charger_ocpp_id for existence and correct type.
        if (entity.charger_ocpp_id == undefined)
            return false;
        if (typeof entity.charger_ocpp_id !== "string")
            return false;
        // Validate entity.charger_model for existence and correct type.
        if (entity.charger_model == undefined)
            return false;
        if (typeof entity.charger_model !== "string")
            return false;
        // Validate entity.port_id for existence and correct type.
        if (entity.port_id == undefined)
            return false;
        if (typeof entity.port_id !== "number")
            return false;
        // If entity.charger_fw_version exists, validate that it has the correct type.
        if (entity.charger_fw_version != undefined) {
            if (typeof entity.charger_fw_version !== "string")
                return false;
        }
        // If entity.charger_sw_version exists, validate that it has the correct type.
        if (entity.charger_sw_version != undefined) {
            if (typeof entity.charger_sw_version !== "string")
                return false;
        }
        // If entity.power_node_sw_version exists, validate that it has the correct type.
        if (entity.power_node_sw_version != undefined) {
            if (typeof entity.power_node_sw_version !== "string")
                return false;
        }
        // If entity.error_code exists, validate that it has the correct type.
        if (entity.error_code != undefined) {
            if (typeof entity.error_code !== "string")
                return false;
        }
        // If entity.fault_category exists, validate that it has the correct type.
        if (entity.fault_category != undefined) {
            if (!ChargerFaultCategoryValidation_1.ChargerFaultCategoryValidation.isValid(entity.fault_category))
                return false;
        }
        // If entity.plug_in_start_utc exists, validate that it has the correct type.
        if (entity.plug_in_start_utc != undefined) {
            if (!(entity.plug_in_start_utc instanceof Date))
                return false;
        }
        // If entity.plug_in_stop_utc exists, validate that it has the correct type.
        if (entity.plug_in_stop_utc != undefined) {
            if (!(entity.plug_in_stop_utc instanceof Date))
                return false;
        }
        // If entity.charging_transaction_start_utc exists, validate that it has the correct type.
        if (entity.charging_transaction_start_utc != undefined) {
            if (!(entity.charging_transaction_start_utc instanceof Date))
                return false;
        }
        // If entity.charging_transaction_end_utc exists, validate that it has the correct type.
        if (entity.charging_transaction_end_utc != undefined) {
            if (!(entity.charging_transaction_end_utc instanceof Date))
                return false;
        }
        // If entity.charge_completed_successfully exists, validate that it has the correct type.
        if (entity.charge_completed_successfully != undefined) {
            if (typeof entity.charge_completed_successfully !== "boolean")
                return false;
        }
        // If entity.start_totalizer_kwh exists, validate that it has the correct type.
        if (entity.start_totalizer_kwh != undefined) {
            if (typeof entity.start_totalizer_kwh !== "number")
                return false;
        }
        // If entity.end_totalizer_kwh exists, validate that it has the correct type.
        if (entity.end_totalizer_kwh != undefined) {
            if (typeof entity.end_totalizer_kwh !== "number")
                return false;
        }
        // If entity.consumed_energy_kwh exists, validate that it has the correct type.
        if (entity.consumed_energy_kwh != undefined) {
            if (typeof entity.consumed_energy_kwh !== "number")
                return false;
        }
        // If entity.peak_power_kw exists, validate that it has the correct type.
        if (entity.peak_power_kw != undefined) {
            if (typeof entity.peak_power_kw !== "number")
                return false;
        }
        // If entity.time_power_limited_ns exists, validate that it has the correct type.
        if (entity.time_power_limited_ns != undefined) {
            if (!(entity.time_power_limited_ns instanceof Date))
                return false;
        }
        // If entity.estimated_amount exists, validate that it has the correct type.
        if (entity.estimated_amount != undefined) {
            if (typeof entity.estimated_amount !== "number")
                return false;
        }
        // If entity.precision exists, validate that it has the correct type.
        if (entity.precision != undefined) {
            if (typeof entity.precision !== "number")
                return false;
        }
        // If entity.idle_time_start_utc exists, validate that it has the correct type.
        if (entity.idle_time_start_utc != undefined) {
            if (!(entity.idle_time_start_utc instanceof Date))
                return false;
        }
        // If entity.idle_time_end_utc exists, validate that it has the correct type.
        if (entity.idle_time_end_utc != undefined) {
            if (!(entity.idle_time_end_utc instanceof Date))
                return false;
        }
        // If entity.evcc_id exists, validate that it has the correct type.
        if (entity.evcc_id != undefined) {
            if (typeof entity.evcc_id !== "string")
                return false;
        }
        // If entity.ocpp_csms_id_token exists, validate that it has the correct type.
        if (entity.ocpp_csms_id_token != undefined) {
            if (typeof entity.ocpp_csms_id_token !== "string")
                return false;
        }
        // If entity.ocpp_csms_id_token_type exists, validate that it has the correct type.
        if (entity.ocpp_csms_id_token_type != undefined) {
            if (typeof entity.ocpp_csms_id_token_type !== "string")
                return false;
        }
        // If entity.finish_code exists, validate that it has the correct type.
        if (entity.finish_code != undefined) {
            if (typeof entity.finish_code !== "number")
                return false;
        }
        // If entity.finish_reason exists, validate that it has the correct type.
        if (entity.finish_reason != undefined) {
            if (!FinishReasonValidation_1.FinishReasonValidation.isValid(entity.finish_reason))
                return false;
        }
        // If entity.uploaded_diagnostics exists, validate that it has the correct type.
        if (entity.uploaded_diagnostics != undefined) {
            if (!Array.isArray(entity.uploaded_diagnostics))
                return false;
            if (!entity.uploaded_diagnostics.every((elem) => {
                if (!DiagnosticFileTypeValidation_1.DiagnosticFileTypeValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        // If entity.power_quality_issues exists, validate that it has the correct type.
        if (entity.power_quality_issues != undefined) {
            if (!Array.isArray(entity.power_quality_issues))
                return false;
            if (!entity.power_quality_issues.every((elem) => {
                if (!PowerQualityIssueValidation_1.PowerQualityIssueValidation.isValid(elem))
                    return false;
                return true;
            }))
                return false;
        }
        return true;
    }
}
exports.ChargingTransactionValidation = ChargingTransactionValidation;
